import Pagination from '@mui/material/Pagination';
import axios from 'axios';
import { format } from 'date-fns';
import { useEffect, useRef, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import '../common-css/Table.css';
import { showTableResponse } from '../common-helpers/commonServices';

const IGPSessions = () => {
    const fileRef1 = useRef(null);
    const fileRef2 = useRef(null);
    const [students, setStudents] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [checked, setChecked] = useState(students)
    // search functionality    
    const [fileUploading1, setFileUploading1] = useState(false);
    const [fileUploading2, setFileUploading2] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    useEffect(() => {
        const filteredStudents = students?.filter(
            item =>
                item?.Name?.toLowerCase().includes(searchTerm?.toLowerCase())
                || item?.EmailId?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
                item?.MobileNo?.includes(searchTerm)
        );
        setChecked(filteredStudents)
    }, [searchTerm])

    const handleSearch = (e) => {
        setSearchTerm(e.target.value)
    }

    //set Table data
    useEffect(() => {
        axios.get(BACKEND_SERVER_URL + '/getIGPSessions').then((res) => {
            let students = res.data?.data
            console.log(students);

            setStudents(students);
            setChecked(students);

        }).catch((error) => {
            console.log(error)
            toast.error(error.response.data.message);
        })
    }, [])



    const pageSize = 100;
    const lastIndex = currentPage * pageSize;
    const firstIndex = lastIndex - pageSize;
    const records = checked.slice(firstIndex, lastIndex);

    const npage = Math.ceil(checked?.length / pageSize)
    const number = [...Array(npage + 1).keys()].slice(1)




    const handlePageChange = (e, p) => {
        setCurrentPage(parseInt(p));
    }
    const formatTime = (timeString) => {
        const [hour, minute] = timeString.slice(11, 16).split(":");
        const h = parseInt(hour);
        const ampm = h >= 12 ? "PM" : "AM";
        const hour12 = h % 12 || 12;
        return `${hour12}:${minute} ${ampm}`;
    };

    const selectedFileHandler = async (file, Sn, fileName) => {
        try {
            setFileUploading1(true);
            const formData = new FormData();
            formData.append('uploadedFile', file, file.name);
            const response = await axios.post(BACKEND_SERVER_URL + '/upload-session-files/' + fileName + '/' + Sn, formData);

        } catch (error) {
            console.log(error);
            toast.error("Error while uploading file")
        } finally {
            fileRef1.current.value = null;
            fileRef2.current.value = null;
            setTimeout(() => {
                setFileUploading1(false);
            }, 1000);

        }

    }

    return (
        <>
            <div className="row">
                <div className="col-xl-12">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className=" page-title  p-2 mb-2">
                                <div className="input-group search-area mb-md-0 mb-3">
                                    <input type="text" className="form-control" onChange={handleSearch} value={searchTerm} placeholder="Search by Name, Email, and Mobile..." />
                                    <span className="input-group-text"><Link to={"#"}>
                                        <svg width="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17.5605 15.4395L13.7527 11.6317C14.5395 10.446 15 9.02625 15 7.5C15 3.3645 11.6355 0 7.5 0C3.3645 0 0 3.3645 0 7.5C0 11.6355 3.3645 15 7.5 15C9.02625 15 10.446 14.5395 11.6317 13.7527L15.4395 17.5605C16.0245 18.1462 16.9755 18.1462 17.5605 17.5605C18.1462 16.9747 18.1462 16.0252 17.5605 15.4395V15.4395ZM2.25 7.5C2.25 4.605 4.605 2.25 7.5 2.25C10.395 2.25 12.75 4.605 12.75 7.5C12.75 10.395 10.395 12.75 7.5 12.75C4.605 12.75 2.25 10.395 2.25 7.5V7.5Z" fill="#01A3FF" />
                                        </svg>
                                    </Link></span>
                                </div>

                            </div>




                        </div>
                        <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                            <div className="dataTables_wrapper no-footer">

                                <div className=" col-12 d-sm-flex text-center justify-content-between align-items-center">
                                    <div>

                                    </div>

                                    <div className='dataTables_info text-dark'>
                                        Records: {checked.length}
                                    </div>
                                    {checked.length > pageSize ?
                                        <div className=" col-7 dataTables_paginate paging_simple_numbers justify-content-end  mb-0 pt-2"
                                            id="example-student_wrapper">

                                            <Pagination count={number.length} variant="outlined" color='primary' size="small" page={currentPage} siblingCount={1} boundaryCount={2} onChange={handlePageChange} />
                                        </div> : null}
                                </div>
                            </div>
                            <div className="table-responsive full-data" style={{ paddingBottom: "1px", transform: 'rotateX(180deg)' }}>
                                <div id="example-student_wrapper" className="dataTables_wrapper no-footer">

                                    <table className="table-responsive-lg table display dataTablesCard student-tab 
                                    dataTable no-footer mt-0  mb-0" id="example-student" style={{ transform: "rotateX(180deg)" }}>
                                        <thead style={{ backgroundColor: "#cccccc" }} className='header-color'>
                                            <tr className='text-center  text-dark  border border-left'>
                                                <th className='p-2 custom-table-header border border-1'>SN.</th>
                                                <th className='  p-2 custom-table-header  border border-2'>STUDENT NAME</th>
                                                <th className=' p-2  text-center custom-table-header  border border-2 '>EMAIL</th>
                                                <th className='  p-2   custom-table-header  border border-2'>INT. DATE</th>
                                                <th className='  p-2   custom-table-header  border border-2'>INT. TIME</th>
                                                <th className='  p-2   custom-table-header  border border-2'>LOCATION</th>
                                                <th className='  p-2   custom-table-header  border border-2'>SESN. VIDEO</th>
                                                <th className='  p-2   custom-table-header  border border-2'>FEEDBACK</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {records.length > 0 ? records.map((item, ind) => (
                                                <tr key={ind} className={`${ind % 2 == 1 ? 'custom text-center' : 'row-height text-center'}`}>
                                                    <td className='text-center p-1 ' style={{ border: "1px solid #cccccc", width: "50px" }}><h6 className="sn-font-weight mb-0" style={{ fontWeight: "bold", maxWidth: "50px" }}> {ind + 1}</h6></td>
                                                    <td className='p-1' style={{ border: "1px solid #cccccc" }}>
                                                        <div className="trans-list sweetalert">
                                                            <h4 className='mb-0 '>{item.FirstName}

                                                            </h4>
                                                        </div>
                                                    </td>


                                                    <td className='p-1 text-start ' style={{ border: "1px solid #cccccc", minWidth: "120px", maxWidth: "150px" }}><h6 className="mb-0">{item.EmailId}</h6></td>
                                                    <td className='text-center p-1' style={{ border: "1px solid #cccccc", width: "85px" }} >
                                                        <h6 className="date mb-0">{format(item?.InterviewDate, "dd/MM/yyyy")}</h6>
                                                    </td>
                                                    <td className='text-center p-1' style={{ border: "1px solid #cccccc", width: "85px" }} >
                                                        <h6 className="date mb-0">{formatTime(item.InterviewTime)}</h6>
                                                    </td>
                                                    <td className='text-center p-1' style={{ border: "1px solid #cccccc", width: "85px" }} >
                                                        <h6 className="date mb-0">{item.Location}</h6>
                                                    </td>
                                                    {/* <td className='text-center p-1' style={{ border: "1px solid #cccccc", width: "85px" }} >
                                                        <button className="date mb-0 btn btn-danger btn-sm p-1 px-2 fw-bold">Upload</button>
                                                    </td> */}
                                                    <td className='text-center p-1' style={{ border: "1px solid #cccccc", width: "85px" }} >
                                                        <input ref={fileRef1} type="file" id="session_video" style={{ display: "none" }} accept=".mp4, .mov, .wmv, .avi, .flv, .webm, .mkv, .mpeg, .3gp"
                                                            onChange={e => selectedFileHandler(e.target.files[0], item.Sn, 'session_video')} />
                                                        <label htmlFor='session_video' className="date mb-0 btn btn-danger btn-sm p-1 px-2 fw-bold">{item.SessionVideo ? 'Uploaded' : 'Upload'}</label>
                                                    </td>
                                                    <td className='text-center p-1' style={{ border: "1px solid #cccccc", width: "85px" }} >
                                                        <input ref={fileRef2} type="file" id="feedback" style={{ display: "none" }} accept=".pdf" onChange={e => selectedFileHandler(e.target.files[0], item.Sn, 'feedback')} />
                                                        <label htmlFor='feedback' className="date mb-0 btn btn-primary btn-sm p-1 px-2 fw-bold">{item.FeedbackReport ? 'Uploaded' : 'Upload'}</label>
                                                    </td>
                                                </tr>
                                            )) :
                                                <tr>
                                                    <td colSpan="9" className="text-center">
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                                            {
                                                                showTableResponse(students, checked)
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default IGPSessions;
